module.exports = __webpack_public_path__ + "img/ari-splash-01-tiny.d5efc522.jpg";